import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const rollingtransConfig: TSPConfig = {
  key: 'rollingtrans',
  name: 'Rollingtrans',
  imageName: 'Rollingtrans',
  category: TSPCategory.API_KEY,
  helpText: 'Enter your Rollingtrans API key to connect your account.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default rollingtransConfig;
